import React, { Component } from "react";

import "bootstrap/dist/css/bootstrap.css";
import "./App.scss";

import Navbar from "./components/navbar";
import Visualizer from "./components/visualizer";
import Modal from "./components/modal";

class App extends Component {
  state = { showModal: true };

  render() {
    return (
      <div className="App">
        <Navbar showModalFn={() => this.setState({ showModal: true })} />
        <Visualizer show={this.state.showModal} />
        <Modal
          show={this.state.showModal}
          onClose={() => this.setState({ showModal: false })}
        />
      </div>
    );
  }
}

export default App;
